import React, { useState } from 'react';
import { Search } from 'lucide-react';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

export function SearchBar({ onSearch }: SearchBarProps) {
  const [query, setQuery] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };

  return (
    <div className="relative mb-4 sm:mb-5">
      <Search className="absolute left-3 sm:left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 sm:h-6 sm:w-6 text-light-textMuted dark:text-dark-textMuted" />
      <input
        type="text"
        placeholder="Cari nama, HP, atau plat motor..."
        value={query}
        onChange={handleInputChange}
        className="input w-full pl-10 sm:pl-14 pr-4 text-base sm:text-lg"
      />
    </div>
  );
}
